module.exports = __webpack_public_path__ + "img/linkedin-icon.70c38144.svg";